import React, { forwardRef } from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// 1. Register the necessary Chart.js components
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

// 2. Configure your chart options
export const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false, // Typically disable stacking if mixing bar and line
  plugins: {
    title: {
      display: true,
      // text: "Mixed Chart Example",
    },
    legend: {
      position: "bottom",
      labels: {
        boxWidth: 10,
        boxHeight: 10,
      },
     
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      grid: {
        drawOnChartArea: false, // Keep grid lines from overlapping
      },
    },
    x: {
      ticks: {
        autoSkip: true,
        maxTicksLimit: 6,
        font: {
          size: 7.5,
        },
      },
    },
  },
};

// 3. Forward the ref if you plan to access the chart instance from outside
const MixedChart = forwardRef(({ data }, ref) => {
  return (
    <div className="charts-card">
      {data && <Chart ref={ref} data={data} options={options} />}
    </div>
  );
});

export default MixedChart;
